
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module.js';
import { purgeOutdatedStorage } from './_helpers/storage-version';

// Avant tout service : aucun ne doit lire un token ou une session au format d'une version précédente
purgeOutdatedStorage();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));